import { render, staticRenderFns } from "./PageHomeArt.vue?vue&type=template&id=0b1b7e7b&scoped=true&"
import script from "./PageHomeArt.vue?vue&type=script&lang=js&"
export * from "./PageHomeArt.vue?vue&type=script&lang=js&"
import style0 from "./PageHomeArt.vue?vue&type=style&index=0&id=0b1b7e7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1b7e7b",
  null
  
)

export default component.exports